import React, { Component } from "react";
import { connect } from "react-redux";
import Table from '@mawesi-sas/mws_react_component_table';
import Input from '@mawesi-sas/mws_react_component_input';
import FontAwesome from "react-fontawesome";

import { getArchivosFromServer } from "../actions";

const WAIT_INTERVAL = 500;
const ENTER_KEY = 13;

class Archivos extends Component {
  componentWillMount() {
    this.props.getArchivosFromServer();
  }

  handleOnChange = value => {
    clearTimeout(this.timer);
    this.setState({ value });
    this.timer = setTimeout(this.triggerChange, WAIT_INTERVAL);
  };

  handleOnKeyDown = key => {
    if (key.keyCode === ENTER_KEY) {
      clearTimeout(this.timer);
      this.triggerChange();
    }
  };

  triggerChange = () => {
    this.props.getArchivosFromServer();
  };

  render() {
    return (
      <div
        style={{
          height: "100%",
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between"
        }}
      >
        <div className="row" style={{ height: "100%" }}>
          <div
            className="col-md-12"
            style={{
              height: "100%",
              display: "flex",
              justifyContent: "space-between",
              flexDirection: "column"
            }}
          >
            {this.props.filter && (
              <div className="buttonstrip" style={{ marginTop: "-10px" }}>
                <Input
                  type="text"
                  reducer="interfazcontable"
                  path="filter_archivos"
                  afterChange={this.handleOnChange}
                  onKeyDown={this.handleOnKeyDown}
                  placeholder="Filtrar..."
                />
              </div>
            )}
            <div
              style={{
                flex: 1,
                padding: "10px 0"
              }}
            >
              <Table
                reducer="interfazcontable"
                table="interfaces"
                take={100}
                whenNoData={
                  <div
                    style={{
                      color: "#888",
                      height: "100%",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      border: "1px solid rgb(221, 221, 221)",
                      background: "rgb(243, 243, 243)"
                    }}
                  >
                    No se encontraron registros que cumplan con los criterios de
                    busqueda
                  </div>
                }
                columns={[
                  {
                    ID: 0,
                    CAPTION: "",
                    VALUE: "selected",
                    TYPE: "selection",
                    INPUT: "checkbox",
                    WIDTH: 24,
                    FIXED: true
                  },
                  {
                    ID: 1,
                    CAPTION: "Archivo",
                    VALUE: "nombre",
                    TYPE: "text"
                  },
                  {
                    ID: 2,
                    CAPTION: "Fecha creación",
                    VALUE: "created_at",
                    TYPE: "date"
                  },
                  {
                    ID: 3,
                    CAPTION: "Solicitudes",
                    WIDTH: 90,
                    TYPE: "custom",
                    RENDER_ROW: reg => {
                      return (
                        <div style={{ textAlign: "right" }}>
                          {reg.get("solicitudes").count()}
                        </div>
                      );
                    }
                  },
                  {
                    ID: 4,
                    CAPTION: "Cafetería",
                    WIDTH: 180,
                    TYPE: "custom",
                    RENDER_ROW: reg => {
                      return (
                        <span style={{ textAlign: "right" }}>
                          {reg
                            .get("solicitudes")
                            .first()
                            .get("nombre_cafeteria")}
                        </span>
                      );
                    }
                  },
                  {
                    ID: 5,
                    CAPTION: "Archivado",
                    WIDTH: 90,
                    TYPE: "custom",
                    RENDER_ROW: reg => (
                      <div
                        style={{
                          textAlign: "center"
                        }}
                      >
                        <FontAwesome
                          name={`${
                            Number(reg.get("procesado")) ? "check-" : ""
                          }square`}
                        />
                      </div>
                    )
                  }
                ]}
                onCambiarPagina={pg => this.props.getArchivosFromServer(pg)}
              />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {};
}

const mapDispatchToProps = {
  getArchivosFromServer
};

export default connect(mapStateToProps, mapDispatchToProps)(Archivos);
